import { defineModule } from '@noodl/noodl-sdk';

import UI_ChatContainer from './reactNodes/ChatContainer';

defineModule({
	reactNodes: [UI_ChatContainer]
});
